import { Box, Typography, Link as MuiLink } from '@mui/material';

const Footer = ({ className = '' }) => {
  return (
    <Box
      component='footer'
      className={`py-3  bg-[#EAEEFD] text-center shadow-md ${className} `}
    >
      <Typography
        variant='body2'
        className='text-gray-500'
        sx={{ display: 'inline' }}
      >
        © Copyrights {new Date().getFullYear()}. All rights reserved. Designed
        by{' '}
      </Typography>
      <MuiLink
        href='https://staticval.com'
        target='_blank'
        rel='noreferrer'
        className='text-blue-600 ml-1'
        underline='hover'
        sx={{ fontSize: 'inherit' }}
      >
        staticval.com
      </MuiLink>
    </Box>
  );
};

export default Footer;
